const SELECTORS = {
  header: '.header',
  stickySection: '.product-sticky-add-to-cart',
  originAddToCartBttn: '[data-add-to-cart]',
  stickyActivedClassName: 'active',
};
const CONFIG = {
  dom: {
    stickySection: document.querySelector(SELECTORS.stickySection),
    originAddToCartBttn: document.querySelector(SELECTORS.originAddToCartBttn),
    header: document.querySelector(SELECTORS.header),
  },
};

/**
 * @param {object} dom object with dom elements
 * @param {string } className class name
 */
function toggleStickyAddToCart(dom, className) {
  const originAddToCartBttnHeight = dom.originAddToCartBttn.clientHeight;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      let isVisible = null;
      if (!entry.isIntersecting && entry.boundingClientRect.bottom - originAddToCartBttnHeight < window.innerHeight) {
        isVisible = true;
      } else if (entry.isIntersecting && entry.boundingClientRect.bottom - originAddToCartBttnHeight < window.innerHeight) {
        isVisible = true;
      } else {
        isVisible = false;
      }
      const isNotCovered = dom.header.getBoundingClientRect().bottom < entry.boundingClientRect.top - originAddToCartBttnHeight;
      const originButtonIsOnScreen = isNotCovered && isVisible;
      if (originButtonIsOnScreen) {
        if (dom.stickySection.classList.contains(className)) {
          dom.stickySection.classList.remove(className);
        }
      } else if (!originButtonIsOnScreen && !dom.stickySection.classList.contains(className)) {
        setTimeout(() => {
          dom.stickySection.classList.add(className);
        }, 100);
      }
    });
  });
  observer.observe(dom.stickySection);
}
/**
 * Init sticky if window inner width is >= 960
 *
 * @param {HTMLElement} stickySection section
 */
function initStickyAddToCart(stickySection) {
  if (stickySection) {
    toggleStickyAddToCart(CONFIG.dom, SELECTORS.stickyActivedClassName);
  }
}
document.addEventListener('DOMContentLoaded', () => {
  const { stickySection } = CONFIG.dom;

  initStickyAddToCart(stickySection);

  window.addEventListener('resize', () => {
    initStickyAddToCart(stickySection);
  });
  window.addEventListener('scroll', () => {
    initStickyAddToCart(stickySection);
  });
});
